import axios from "axios";
import { UIactions } from "../../../store/slices/UI";
import { warehouseActions } from "../../../store/slices/warehouse";
import { workerActions } from "../../../store/slices/workers";

export const getChannelMessagesId = "getChannelMessages";
export const channelMessagesDataId = "channelMessages";
export const channelMessagesTotalId = "channelMessagesTotal";

const getChannelMessages = ({
  M365server,
  cloner_key,
  channelId,
  query = "",
  controller,
}) => {
  const id = getChannelMessagesId;

  return async (dispatch) => {
    dispatch(workerActions.start(id));
    try {
      const url = `${M365server}mailapi/teams/channel/${channelId}/message${query}`;
      const response = await axios.get(url, {
        signal: controller?.signal,
        headers: { cloner_key },
      });

      // The endpoint may answer 204 with an empty body when there are no
      // messages; axios returns response.data as "" in that case.
      const data = response.data;
      if (data && typeof data === "object" && Array.isArray(data.messages)) {
        dispatch(
          warehouseActions.load({
            id: channelMessagesDataId,
            data: data.messages,
          })
        );
        dispatch(
          UIactions.setValue({
            id: channelMessagesTotalId,
            value: data.total_messages ?? data.messages.length,
          })
        );
      } else {
        dispatch(warehouseActions.load({ id: channelMessagesDataId, data: [] }));
        dispatch(UIactions.setValue({ id: channelMessagesTotalId, value: 0 }));
      }

      dispatch(workerActions.finish({ id }));
    } catch (e) {
      if (e.code === "ERR_CANCELED") {
        dispatch(workerActions.clear(id));
        return;
      }
      console.error(e);
      dispatch(workerActions.finish({ id, error: e.message }));
    }
  };
};

export default getChannelMessages;
